function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, String, affectedMessageIds, error, open, showDeleteModal, stagedCustomEvent) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['alert-error-message'] = function(errorDescription, apiErrorMessage) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'text': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("" + (errorDescription) + ". " + (apiErrorMessage) + ". If this issue persists please ");
            __jade_nodes = __jade_nodes.concat((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: 'https://mixpanel.com/get-support',
                  target: '_blank'
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("contact support");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this));
            __jade_nodes = __jade_nodes.concat(".");;
            return __jade_nodes
          }).call(this));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const numAffectedMessages = (affectedMessageIds || []).length;
    const messagePlural = $helpers.pluralize('message', numAffectedMessages);
    const pausedMessagesText = `${numAffectedMessages} ${messagePlural} using this event will be paused`;
    return {
      value: (h("mp-modal", {
        "attrs": __vjadeStringifyAttrsIfObj({
          open,
          closeable: true,
          'grow-to-content': true,
          'close-confirm-text': this.helpers.hasUnsavedChanges() ? `Changes  made will not be applied.` : ``,
        }),
        "on": {
          change: $helpers.handleModalChange,
        },
        "class": {
          'custom-event-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-event-modal-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-header-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-modal-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-modal-title': true
                },
              }, [__vjadeSafeCode($helpers.isNewCustomEvent() ? `Create Custom Event` : `Edit Custom Event - ${stagedCustomEvent.name}`)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("mp-sharing-banner", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getSharingBannerAttrs()),
            "class": {
              'sharing-banner': true
            },
          }));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-event-name-subheader': true
            },
          }, (function() {
            var __jade_nodes = [];
            const nameHasError = error.invalidName || error.duplicateName;
            const nameErrorMessage = nameHasError ? (error.invalidName ? `Please name your custom event` : `A custom event with that name already exists`) : ``;
            __jade_nodes = __jade_nodes.concat(h("mp-input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                maxlength: $helpers.MAX_NAME_LENGTH,
                label: `Name`,
                necessary: `required`,
                'validation-status': nameHasError ? `invalid` : ``,
                'error-message': nameErrorMessage,
              }),
              "on": {
                input: $helpers.updateCustomEventName,
                focus: $helpers.clearNameErrors,
              },
              "hook": {
                insert: $helpers.nameInputInserted,
              },
              "props": {
                value: stagedCustomEvent.name,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-modal-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-event-match-text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Match my custom event when any of the following events happen");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-event-builder': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-query-entry-section", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'data-groups-enabled': $attr(`all-data-groups`),
                  'disable-first-time-event-filters': true,
                  'entries': JSON.stringify($helpers.getEntries()),
                  'enable-enhanced-list-filters': true,
                  'hide-edit-controls': true,
                  'include-custom-properties': `persisted-non-behavioral-only`,
                  'project-has-people': this.attr(`project-has-people`),
                  'project-id': this.attr(`project-id`),
                  'row-draggable': true,
                  'row-label-type': `none`,
                  'workspace-id': $attr(`workspace-id`),
                  'project-as-of-date': $attr(`project-as-of-date`),
                  'track-name': $attr(`track-name`),
                }),
                "on": {
                  update: $helpers.updateQueryEvents,
                  track: $helpers.captureTracking,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            const canSaveCustomEvent = $helpers.isStagedCustomEventValid();
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'delete-custom-event-button': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((stagedCustomEvent.id) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "key": 'delete-custom-event-button',
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `secondary`,
                    type: `destructive`,
                    icon: `trashcan`,
                    elref: `deleteCustomEventButton`,
                  }),
                  "on": {
                    click: $helpers.clickDeleteCustomEvent
                  },
                  "class": {
                    'delete-custom-event-button': true
                  },
                }));
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    placement: `right`
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Delete custom event");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : ($helpers.showShareManagement()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    theme: `secondary`,
                    disabled: !canSaveCustomEvent,
                  }),
                  "on": {
                    click: () => $helpers.clickSave({
                      andShare: true
                    })
                  },
                  "class": {
                    'save-and-share-button': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Save and Share");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'messages-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((numAffectedMessages > 0) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'notifications-pause-warning': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: `info`
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("span", [__vjadeSafeCode(`${numAffectedMessages} ${messagePlural} using this event will be paused`)]));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'modal-actions': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                  disabled: !canSaveCustomEvent,
                }),
                "on": {
                  click: $helpers.clickSave
                },
              }, [__vjadeSafeCode(numAffectedMessages > 0 ? `Save & pause ${messagePlural}` : `Save`)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean))); /*  TODO(mack): Convert this to use mp-confirm */
        /*  This is a somewhat gruesome cobbled-together version of mp-confirm to avoid */
        /*  the modal-in-a-modal problem. Not a pattern to be repeated. */
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": __vjadeStringifyAttrsIfObj({
            open: showDeleteModal,
          }),
          "class": {
            'delete-custom-event-modal': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-confirm-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-body': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-title': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Delete custom event");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'mp-confirm-description': true
                  },
                }, [__vjadeSafeCode(`Reports and cohorts using this custom event will be affected.`)]));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-confirm-buttons': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `tertiary`
                }),
                "on": {
                  click: $helpers.cancelDeleteCustomEvent
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  theme: `primary`,
                  type: `destructive`,
                  elref: `confirmDeleteCustomEvent`
                }),
                "on": {
                  click: $helpers.confirmDeleteCustomEvent
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Delete custom event");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat((error['saveCustomEvent']) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-toast-portal", {
            "props": {
              toast: {
                isStatic: true,
                message: $mixins['alert-error-message'](`Your custom event could not be saved`, error['message']),
                type: `error`,
                closeToastCallback: $helpers.handleErrorToastClosed,
              }
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((error['deleteCustomEvent']) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-toast-portal", {
            "props": {
              toast: {
                isStatic: true,
                message: $mixins['alert-error-message'](`Your custom event could not be deleted`, error['message']),
                type: `error`,
                closeToastCallback: $helpers.handleErrorToastClosed,
              }
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "affectedMessageIds" in locals ? locals.affectedMessageIds : typeof affectedMessageIds !== "undefined" ? affectedMessageIds : undefined, "error" in locals ? locals.error : typeof error !== "undefined" ? error : undefined, "open" in locals ? locals.open : typeof open !== "undefined" ? open : undefined, "showDeleteModal" in locals ? locals.showDeleteModal : typeof showDeleteModal !== "undefined" ? showDeleteModal : undefined, "stagedCustomEvent" in locals ? locals.stagedCustomEvent : typeof stagedCustomEvent !== "undefined" ? stagedCustomEvent : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;